<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { commonService } from "@/services/common";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import TableLoading from "@/components/ipos/table-loading";
import { quotationService } from "@/services/authservice/quotation";
import { itemService } from "@/services/authservice/item";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import { base } from "@/services/base";
import UtilsMixin from "@/mixins/utils";
import {listTypePrice, listVatType} from "@/services/constant";
import {majorService} from "@/services/authservice/major";
import ReplaceComponent from "@/router/views/quotation/replace";
import ComponentCurrencyInput from "@/components/currency";
export default {
  page: {
    title: "Tạo phiếu báo giá",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {ComponentCurrencyInput, ReplaceComponent, Layout, PageHeader, Multiselect, DatePicker, TableLoading },
  mixins: [UtilsMixin],
  data: function () {
    return {
      title: "Tạo phiếu báo giá",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Phiếu báo giá",
          href: "/quotation",
        },
        {
          text: "Tạo phiếu báo giá",
          active: true,
        },
      ],
      listProductAll: [],
      listProductByBrand: [],
      listProduct: [],
      listChannel: [],
      selectedItem: [],
      listBrand: [],
      formData: {
        channel: [],
        brand: "",
        startDate: "",
        endDate: "",
        note: "",
        quotation_type: listTypePrice[0],
        gr: undefined
      },
      keyword: "",
      isBusy: true,
      isBtnLoading: false,
      fileImport: null,
      step: 1,
      tabCheck: 1,
      listError: [],
      listSuccess: [],
      isLoadingCheck: false,
      loadUnit: false,
      listTypePrice,
      listOrderGr: [], // danh sách nhập mua hàng từ nhãn
      loadGr: false,
      loadDetailGr: false,
      listVatType,
      //selectTable
      allSelected: false,
      indeterminate: false,
      listCheckBoxItem: [],
      keywordDataSelectTable: "",
    };
  },

  beforeMount() {
    this.getInitData();
  },

  computed: {
    searchDataSelectedTable() {
      const searchFormat = this.keywordDataSelectTable && this.keywordDataSelectTable.trim() && this.convertVnTextToEnglish(this.keywordDataSelectTable.trim()) || '';
      return this.selectedItem.filter(item => {
        return !searchFormat || this.convertVnTextToEnglish(item.name).includes(searchFormat);
      });
    },
  },

  watch: {
    listCheckBoxItem(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length === this.selectedItem.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  },

  methods: {
    async getInitData() {
      this.isBusy = true;
      // get list brand
      const resBrand = await commonService.getListBrand();
      if (resBrand.data.error) {
        this.listBrand = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: resBrand.data.error.message,
        });
      } else {
        this.listBrand = resBrand.data.data;
      }
      // get list unit
      const resUnit = await commonService.getListUnit();
      this.listUnit = resUnit.data.data;
      // get list sale channel
      const resChannel = await commonService.getListSaleChannel();
      this.listChannel = resChannel.data.data;
      this.isBusy = false;
    },

    onChangePromotionType(e){
      this.selectedItem = [];
      if(e.id === 'IMPORT'){
        this.getListReceipt()
      }
    },

    async onChangeBrand(value, type) {
      this.keyword = "";
      this.listProduct = this.listProductAll;
      if (value !== null) {
        // get list item
        const resItem = await itemService.getList({
          active: 1,
          trademark_uid: value.id,
        });
        if (resItem.data.error) {
          this.listProductAll = [];
          this.listProductByBrand = [];
          this.listProduct = [];
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: resItem.data.error.message,
          });
        } else {
          this.listProductAll = resItem.data.data;
          this.listProductByBrand = resItem.data.data;
          this.listProduct = resItem.data.data;
          if(type) this.selectedItem = [];
        }
        if(type) await this.getListReceipt()
      }
    },

    async getListReceipt() {
      this.loadGr = true
      const response = await majorService.getList({
        results_per_page: 10000,
        gr_type: 'NMH',
        trademark_uid: this.formData.brand&&this.formData.brand.id || undefined,
        status: 'COMPLETED'
      });
      if (response.data.error) {
        this.listOrderGr = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: response.data.error.message,
        });
      } else {
        this.listOrderGr = response.data.data.map((e)=>{
          return {
            id: e.id,
            gr_id: e.gr_id,
            trademark_uid: e.trademark_uid,
            gr_time: e.gr_time
          }
        });
        if(this.formData.gr&&this.formData.gr.id&&!this.listOrderGr.find(el => el.id === this.formData.gr.id)){
          this.formData.gr = undefined
        }
      }
      this.loadGr = false
    },

    async onChangeGr(e) {
      if(e){
        this.loadDetailGr = true
        if (!(this.formData.brand && this.formData.brand.id)) {
          this.formData.brand = this.listBrand.find(el => el.id === e.trademark_uid)
          this.onChangeBrand(this.formData.brand, false)
        }
        // get detail
        const resDetail = await majorService.getList({
          uid: e.id,
        });
        if (resDetail.data.error) {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: resDetail.data.error.message,
          });
        } else {
          this.selectedItem = resDetail.data&&resDetail.data.data.details.map((e)=>{
            const unit = {
              id: e.unit_uid,
              unit_id: e.unit_id,
              unit_name: e.unit_name
            }
            return{
              id: e.item_uid,
              name: e.item_name,
              unit,
              price: e.price,
              vat: 0
            }
          }) || [];
        }
        this.loadDetailGr = false
      }
    },

    onSelectedItem(data) {
      this.selectedItem.push({ ...data, vat: 0 });
      this.handleSortItem()
    },

    handleSortItem(){
      const new_list = []
      this.selectedItem.forEach(e=>{
        const index = new_list.findIndex(el => el.id === e.id)
        if(index > -1){
          new_list.splice(index, 0, e)
        }else{
          new_list.push(e)
        }
      })
      this.selectedItem = new_list
    },

    onReplaceMultiple(){
      if(this.listCheckBoxItem.length){
        this.$refs.replaceComponent.onShow()
      }else{
        this.$notify({
          group: "app",
          type: "error",
          title: "Chưa chọn hàng hóa",
          text: "Vui lòng chọn hàng hóa cần thay thế",
        });
      }
    },

    handleReplaceMultiple(e){
      this.$refs.replaceComponent.onClose()
      this.selectedItem.forEach((obj) => {
        if (this.listCheckBoxItem.find(el => el.id === obj.id)) {
          obj.vat = e
        }
      });
      this.listCheckBoxItem = []
    },

    toggleAll(e){
      if(e){
        this.listCheckBoxItem = this.selectedItem.map((e)=> e)
      }else{
        this.listCheckBoxItem = []
      }
    },

    renderUnit(id) {
      const find = this.listUnit.filter((e) => e.id === id);
      return find[0].unit_name;
    },

    onRemoveAll() {
      this.selectedItem = [];
    },

    onChangePrice(value, row) {
      row.price =  this.parseCurrency(value||0);
    },

    removeItem(index) {
      this.listCheckBoxItem = []
      this.selectedItem.splice(index, 1);
    },

    onSearchItem(key) {
      this.keyword = key;
      key = this.convertVnTextToEnglish(key.toUpperCase())
      this.listProduct = this.listProductAll;
      if (key !== null && key !== "" && key !== undefined) {
        let cloneArr = JSON.parse(JSON.stringify(this.listProductByBrand));
        this.listProduct = cloneArr.filter(
          (e) =>
            this.convertVnTextToEnglish(e.name.toUpperCase()).indexOf(
              key.toUpperCase()
            ) >= 0 ||
            this.convertVnTextToEnglish(e.sku).indexOf(key.toUpperCase()) >= 0
        );
      }
    },

    handleCheckItem(){
      for (let i=0; i<this.selectedItem.length; i++){
        const item = this.selectedItem[i]
        const list_item_same = this.selectedItem.filter(el=>el.id === item.id && el.unit.id === item.unit.id)
        if(list_item_same.length > 1){
          this.$notify({
            group: "app",
            type: "warn",
            title: "Chú ý",
            text: `Hàng hóa ${item.name} xảy ra trùng lặp giống đơn vị tính`,
          });
          return false
        }
      }
      return true
    },

    async onCreateQuotation() {
      if (
        this.selectedItem.length > 0 &&
        this.formData.startDate &&
        this.formData.brand &&
        this.formData.quotation_type &&
        ((this.formData.quotation_type.id === 'EXPORT' && this.formData.channel) || this.formData.quotation_type.id === 'IMPORT')
      ) {
        const check_list_item = this.handleCheckItem()
        if(!check_list_item){
          return
        }
        const detailItem = this.selectedItem.map((e) => {
          return {
            price: e.price,
            vat: e.vat || 0,
            item_uid: e.id,
            unit_uid: e.unit.id
          };
        });
        const body = {
          from_date: this.formData.startDate.getTime(),
          to_date: this.formData.endDate
            ? this.formData.endDate.getTime()
            : null,
          note: this.formData.note,
          trademark_uid: this.formData.brand.id,
          quotation_type: this.formData.quotation_type&&this.formData.quotation_type.id || undefined,
          details: detailItem,
        };
        if(body.quotation_type === 'EXPORT') {
          body.list_sale_channel_id = this.formData.channel
              .map((e) => e.channel_id)
              .includes("ALL")
              ? ["ALL"]
              : this.formData.channel.map((e) => e.channel_id)
        }else{
          body.list_sale_channel_id = ['ALL']
        }
        this.isBtnLoading = true;
        const res = await quotationService.addNew(body);
        if (res.data.error) {
          this.$notify({
            group: "app",
            type: "error",
            title: "Tạo đơn lỗi",
            text: res.data.error.message,
          });
        } else {
          this.$notify({
            group: "app",
            type: "success",
            title: "Tạo bảng giá thành công",
          });
          this.resetForm();
        }
        this.isBtnLoading = false;
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Nhập đầy đủ thông tin",
          text: "Vui lòng nhập đầy đủ thông tin",
        });
      }
    },

    resetForm() {
      this.formData = {
        channel: "",
        brand: "",
        startDate: "",
        endDate: "",
        note: "",
        quotation_type: this.listTypePrice[0]
      };
      this.selectedItem = [];
      this.isBtnLoading = false;
    },

    onExport() {
      let product = this.listProductAll.filter(
        (e) => e.trademark_uid === this.formData.brand.id
      );
      let workbook = new Workbook();
      let header = [
        { header: "Mã hàng hoá (*)", key: "sku" },
        { header: "Tên hàng hoá", key: "item_name" },
        { header: "Đơn vị tính (*)", key: "unit_id" },
        { header: "Đơn giá (*)", key: "price" },
        { header: "VAT", key: "vat" },
      ];
      const worksheet = workbook.addWorksheet("Danh sách hàng hoá");
      worksheet.properties.defaultColWidth = 40;
      worksheet.columns = header;

      let formatProduct = product.map((e) => {
        return {
          sku: e.sku,
          item_name: e.name,
          unit_id: e.unit.unit_id,
        };
      });

      formatProduct.forEach((d) => {
        worksheet.addRow(d);
      });
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell) => {
          if (rowNumber === 1) {
            row.font = { bold: true };
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
            for (let i = 1; i <= 5; i++) {
              row.getCell(i).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "C7C7C7" },
              };
              row.getCell(i).border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          } else {
            cell.alignment = {
              wrapText: true,
            };
            for (let i = 1; i <= 5; i++) {
              row.getCell(i).border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          }
        });
      });

      // Generate Excel File with given name
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fs.saveAs(blob, `EXPORT_PRODUCT_${new Date().getTime()}.xlsx`);
      });
    },

    async onExportTemplate() {
      let product = []
      let resItem = await itemService.getList({
        active: 1,
        trademark_uid: this.formData.brand.id,
      });
      if (resItem.data.error) {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: resItem.data.error.message,
          });
        } else {
          product = resItem.data.data;
        }
      let workbook = new Workbook();
      let header = [
        { header: "Mã hàng hoá (*)", key: "sku" },
        { header: "Tên hàng hoá", key: "item_name" },
        { header: "Đơn vị tính (*)", key: "unit_id" },
        { header: "Đơn giá (*)", key: "" },
        { header: "VAT", key: "" },
      ];
      const worksheet = workbook.addWorksheet("Danh sách hàng hoá");
      worksheet.properties.defaultColWidth = 40;
      worksheet.columns = header;

      let formatProduct = product.map((e) => {
        return {
          sku: e.sku,
          item_name: e.name,
          unit_id: e.unit.unit_id,
        };
      });

      formatProduct.forEach((d) => {
        worksheet.addRow(d);
      });
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell) => {
          if (rowNumber === 1) {
            row.font = { bold: true };
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
            for (let i = 1; i <= 5; i++) {
              row.getCell(i).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "C7C7C7" },
              };
              row.getCell(i).border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          } else {
            cell.alignment = {
              wrapText: true,
            };
            for (let i = 1; i <= 5; i++) {
              row.getCell(i).border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          }
        });
      });

      // Generate Excel File with given name
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fs.saveAs(blob, `EXPORT_PRODUCT_${new Date().getTime()}.xlsx`);
      });
    },

    handleImport() {
      this.$bvModal.show("md-import");
    },

    onChangeTab(id) {
      if (this.fileImport !== null) {
        this.step = id;
      }
    },

    onChangeTabCheck(id) {
      this.tabCheck = id;
    },

    async onShowUnit(data) {
      this.loadUnit = true
      this.listUnit = []
      if (data.unit && data.unit.id) {
        const res = await itemService.getListUnitByItem({
          item_uid: data.id,
          unit_uid: data.unit.id
        })
        if (res.data && res.data.data) {
          this.listUnit = res.data.data
        } else {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: res.data && res.data.error && res.data.error.message || 'Error',
          });
        }
      }
      this.loadUnit = false
    },

    async handleChangeUnit(value, row) {
      row.unit = value
      const res = await itemService.getPriceByItemUnit({
        item_uid: row.id,
        unit_uid: value.id,
        sale_channel: 'ALL'
      })
      if (res.data && res.data.data) {
        const {
          price,
          vat
        } = res.data.data
        row.price = price || 0
        row.vat = vat || 0
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: res.data && res.data.error && res.data.error.message || 'Error',
        });
      }
    },

    async onCheckFile() {
      if (this.fileImport) {
        this.isLoadingCheck = true;
        let formData = new FormData();
        formData.append("file", this.fileImport);
        const response = await base.preImport(formData, {
          trademark_uid: this.formData.brand.id,
          data_type: "QUOTATION",
          list_sale_channel_id: this.formData.channel && this.formData.channel.length && this.formData.channel
            .map((e) => e.channel_id)
            .includes("ALL")
            ? ["ALL"]
            : this.formData.channel.map((e) => e.channel_id),
        });
        if (response.data.error) {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: response.data.error.message,
          });
        } else {
          this.listError = response.data.data.error_list;
          this.listSuccess = response.data.data.success_list;
          if (this.listError.length > 0) {
            this.tabCheck = 1;
          } else {
            this.tabCheck = 2;
          }
          this.step = 2;
        }
        this.isLoadingCheck = false;
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Bạn phải chọn file dữ liệu",
        });
      }
    },

    async onImport() {
      this.selectedItem = this.listSuccess.map((e) => {
        const unit = {
          id: e.unit_uid,
          unit_id: e.unit_id,
          unit_name: e.unit_name
        }
        return { ...e, name: e.item_name, id: e.item_uid, unit };
      });
      this.$bvModal.hide("md-import");
    },

    resetHideForm() {
      this.listError = [];
      this.listSuccess = [];
      this.$bvModal.hide("md-import");
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" style="margin-left: -5px;margin-right: -5px;">
      <div class="col-lg-5 col-md-12 col-sm-12" style="padding-left: 5px; padding-right: 5px;">
        <div class="input-no-br bg-white box-shadow p-3 h-100">
          <TableLoading v-if="isBusy" />
          <div v-else class="input-no-br">
            <div class="d-flex">
              <div class="custom-input-group w150">Loại giá</div>
              <multiselect
                  id="quotation-type"
                  v-model="formData.quotation_type"
                  :options="listTypePrice"
                  track-by="id"
                  label="name"
                  placeholder="Chọn loại giá"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  class="custom-multi-select"
                  :allow-empty="false"
                  @input="(e)=>onChangePromotionType(e)"
              ></multiselect>
            </div>
            <div class="d-flex mtn1">
              <div class="custom-input-group w150">Nhãn hàng</div>
              <multiselect
                  id="brand"
                  v-model="formData.brand"
                  :options="listBrand"
                  track-by="id"
                  label="trademark_name"
                  placeholder="Chọn nhãn hàng áp dụng"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  class="custom-multi-select"
                  @input="(e)=>onChangeBrand(e, true)"
              ></multiselect>
            </div>
            <div v-if="formData.quotation_type&&formData.quotation_type.id === 'IMPORT'" class="d-flex mtn1">
              <div class="custom-input-group w150">Phiếu nhập hàng</div>
              <multiselect
                  id="gr"
                  v-model="formData.gr"
                  :options="listOrderGr"
                  track-by="id"
                  label="gr_id"
                  placeholder="Chọn phiếu nhập hàng để áp dụng"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  class="custom-multi-select"
                  :loading="loadGr"
                  @input="onChangeGr"
              >
                <template slot="option" slot-scope="{option}">
                  <div class="multiselect-tittle">{{option.gr_id}}</div>
                  <div class="multiselect-content pl-1">
                    <div class="multiselect-sub-title">- {{formatDate(option.gr_time)}}</div>
                  </div>
                </template>
              </multiselect>
            </div>
            <div v-if="formData.quotation_type&&formData.quotation_type.id === 'EXPORT'" class="d-flex mtn1">
              <div class="custom-input-group w150">Kênh áp dụng</div>
              <multiselect
                  id="channel"
                  v-model="formData.channel"
                  :options="listChannel"
                  track-by="channel_id"
                  label="channel_name"
                  placeholder="Chọn kênh áp dụng"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  class="custom-multi-select"
                  :multiple="true"
              ></multiselect>
            </div>

            <div class="d-flex mtn1">
              <div class="custom-input-group" style="min-width: 150px">
                Ngày bắt đầu
              </div>
              <date-picker
                  id="startDate"
                  v-model="formData.startDate"
                  :first-day-of-week="1"
                  lang="vi"
                  format="DD/MM/YYYY"
                  placeholder="Chọn thời gian"
                  class="custom-datepicker"
              ></date-picker>
            </div>
            <div class="d-flex mtn1">
              <div class="custom-input-group" style="min-width: 150px">
                Ngày kết thúc
              </div>
              <date-picker
                  id="endDate"
                  v-model="formData.endDate"
                  :first-day-of-week="1"
                  lang="vi"
                  format="DD/MM/YYYY"
                  placeholder="Chọn thời gian"
                  class="custom-datepicker"
              ></date-picker>
            </div>
          </div>

        </div>
      </div>
      <div class="col-lg-7 col-md-12 col-sm-12" style="padding-left: 5px; padding-right: 5px;">
        <div class="box-shadow bg-white p-2 h-100">
          <TableLoading v-if="isBusy"/>
          <div v-else-if="!(formData.brand&&formData.brand.id)" class="text-center d-block">Chọn nhãn hàng để lấy thông tin sản phẩm</div>
          <template v-else>
            <div
                class="product-container d-flex"
            >
              <div class="product-data w-100">
                <b-input-group class="custom-search">
                  <b-input
                      type="text"
                      id="search"
                      placeholder="Tìm kiếm hàng hoá"
                      v-model="keyword"
                      @input="onSearchItem($event)"
                  ></b-input>
                  <i class="bx bx-search"></i>
                </b-input-group>
                <div class="overflow-y-auto" style="max-height: 300px">
                  <div class="container-fluid mt-2">
                    <div
                        class="row"
                    >
                      <div
                          v-for="product in listProduct"
                          class="col-sm-6 col-md-6 col-xl-6 pd-select"
                          style="padding-left: 2.5px; padding-right: 2.5px"
                          :key="product.id"
                      >
                        <div v-b-tooltip.hover.bottom :title="product.name" class="pd-item" @click="onSelectedItem(product)">
                          <p>{{ `${product.sku} - ${product.name}` }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
                class="m-auto text-center py-3"
                style="border-top: 1px solid #eee"
            >
              <div class="alert alert-info">
                Để khai báo giá nhanh bạn có thể tải xuống danh sách sản phẩm,
                chỉnh sửa giá và import khai báo giá.
                <a @click="onExport" href="javascript:void(0)"
                >Tải danh sách sản phẩm</a
                >
              </div>
              <a
                  @click="handleImport"
                  class="btn btn-outline-primary mb-1"
                  href="javascript:void(0)"
              >
                Import khai báo giá
              </a>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="mt-2 w-100">
      <div class="product-container d-flex box-shadow bg-white mb-2 p-3 flex-column">
        <TableLoading v-if="isBusy" />
        <template v-else>
          <b-input-group class="custom-search mb-2">
            <b-input
                type="text"
                id="search"
                placeholder="Tìm kiếm hàng hoá"
                v-model="keywordDataSelectTable"
                style="max-width: 300px"
            ></b-input>
            <i class="bx bx-search"></i>
          </b-input-group>
          <div class="table-responsive table-responsive-order-detail">
            <table class="table table-bordered scroll-table">
              <thead>
              <tr>
                <th scope="col" class="select-box-table" style="width: 60px;">
                  <b-form-checkbox
                      v-model="allSelected"
                      :indeterminate="indeterminate"
                      aria-describedby="flavours"
                      aria-controls="flavours"
                      @change="toggleAll"
                  />
                </th>
                <th scope="col" class="min-w-140">
                  Hàng hoá
                  {{
                    selectedItem.length > 0 ? `(${selectedItem.length})` : ""
                  }}
                </th>
                <th scope="col" class="min-w-140">ĐVT</th>
                <th scope="col" class="min-w-100">Giá</th>
                <th scope="col" class="min-w-100">
                  <span>VAT (%)</span>
                  <button
                      class="btn btn-sm btn-no-bg-primary ml-2"
                      @click="onReplaceMultiple()"
                  >
                    <i class="bx bx-edit align-middle font-size-18"></i>
                  </button>
                </th>
                <th scope="col">
                  <i
                      @click="onRemoveAll()"
                      class="bx bx-revision font-size-16 text-danger ipos-pointer"
                  ></i>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in searchDataSelectedTable" :key="item+index">
                <td class="select-box-table">
                  <b-form-checkbox
                      v-model="listCheckBoxItem"
                      :key="item.id+'_checkbox'"
                      :value="item"
                  />
                </td>
                <td>
                  <div>{{ item.sku }}</div>
                  <div>{{ item.name }}</div>
                </td>
                <td style="width: 220px">
                  <multiselect
                      id="unit"
                      :value="item.unit"
                      :options="listUnit"
                      track-by="id"
                      label="unit_name"
                      placeholder="Chọn đơn vị tính"
                      noOptions="Danh sách trống"
                      @open="onShowUnit(item)"
                      :show-labels="false"
                      :loading="loadUnit"
                      class="max-w200"
                      @select="(e)=>handleChangeUnit(e,item)"
                      open-direction="bottom"
                  ></multiselect>
                </td>
                <td>
                  <b-input-group class="sm-group min-w-75">
                    <b-input
                        class="text-center"
                        @input="onChangePrice($event, item)"
                        type="text"
                        :value="item.price"
                    ></b-input>
                  </b-input-group>
                </td>
                <td>
                  <b-input-group class="sm-group min-w-75 d-flex justify-content-center">
                    <component-currency-input v-model="item.vat" :min="0" :max="100" class="text-center" />
                  </b-input-group>
                </td>
                <td>
                  <i
                      @click="removeItem(index)"
                      class="bx bx-x-circle font-size-16 text-danger ipos-pointer"
                  ></i>
                </td>
              </tr>
              <tr v-if="selectedItem.length === 0">
                <td colspan="6">
                  <p class="p-3 m-0 text-center">Chưa chọn hàng hoá</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive mb-0 bg-white box-shadow">
            <TableLoading v-if="isBusy" />
            <div v-else class="p-3" style="border: 1px solid #eff2f7">
              <div class="d-flex align-content-center justify-content-between">
                <b-input
                    class="mb-3"
                    type="text"
                    id="note"
                    v-model="formData.note"
                    placeholder="Ghi chú (nếu có)"
                ></b-input>
              </div>
              <div class="d-flex align-content-center justify-content-end">
                <button
                    class="btn btn-primary w-md d-block"
                    type="submit"
                    @click="onCreateQuotation()"
                    v-bind:disabled="isBtnLoading"
                >
                  <template v-if="isBtnLoading">
                    <i
                        class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
                    ></i>
                    Đang xử lý...
                  </template>
                  <template v-else>Tạo mới</template>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- Modal Import -->
    <b-modal
      id="md-import"
      title="Import hàng hoá khai báo giá"
      @hidden="resetHideForm"
      size="lg"
      centered
      hide-footer
    >
      <form>
        <div class="row mb-3">
          <div class="col-lg-3">
            <a
              @click="onChangeTab(1)"
              class="btn rounded-pill mb-2"
              :class="{ 'btn-secondary': step === 1, 'btn-light': step === 2 }"
            >
              Bước 1: Chọn file
            </a>
            <a
              @click="onChangeTab(2)"
              class="btn rounded-pill"
              :class="{ 'btn-secondary': step === 2, 'btn-light': step === 1 }"
            >
              Bước 2: Kiểm tra dữ liệu
            </a>
          </div>
          <div class="col-lg-9">
            <div class="row" v-if="step === 1">
              <div class="col-lg-12">
                <p class="mb-2">
                  Chọn file dữ liệu chuẩn bị import vào phần mềm
                </p>
                <b-form-file
                  v-model="fileImport"
                  :state="Boolean(fileImport)"
                  placeholder="Chọn file hoặc kéo file vào đây..."
                  drop-placeholder="Kéo file vào đây..."
                ></b-form-file>
                <p class="mt-2">
                  Tải tệp excel mẫu
                  <a href="javascript:void(0)" @click="onExportTemplate"
                    >tại đây</a
                  >
                </p>
              </div>
            </div>
            <div class="row" v-if="step === 2">
              <div class="col-lg-12" v-if="listError.length > 0">
                <div class="alert alert-danger">
                  Vui lòng kiểm tra và chỉnh sửa lại file import, có lỗi ở các
                  dòng dưới đây
                </div>
              </div>
              <div class="col-lg-12">
                <a
                  @click="onChangeTabCheck(1)"
                  class="btn btn-sm rounded-pill mr-2 mb-3"
                  :class="{
                    'btn-danger': tabCheck === 1,
                    'btn-outline-secondary': tabCheck === 2,
                  }"
                >
                  Lỗi ({{ listError.length }})
                </a>
                <a
                  @click="onChangeTabCheck(2)"
                  class="btn btn-sm rounded-pill mb-3"
                  :class="{
                    'btn-success': tabCheck === 2,
                    'btn-outline-secondary': tabCheck === 1,
                  }"
                >
                  Hợp lệ ({{ listSuccess.length }})
                </a>
              </div>
              <div
                class="col-lg-12"
                v-if="tabCheck === 1 && listError.length > 0"
              >
                <table class="table table-bordered">
                  <tr>
                    <th>Mã</th>
                    <th>Tên</th>
                    <th>Lỗi</th>
                  </tr>
                  <tr v-for="(item, i) in listError" :key="i">
                    <td>{{ item.sku }}</td>
                    <td>{{ item.item_name }}</td>
                    <td>
                      <span class="text-danger">{{ item.error_message }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div
                class="col-lg-12"
                v-if="tabCheck === 2 && listSuccess.length > 0"
              >
                <table class="table table-bordered">
                  <tr>
                    <th>Mã</th>
                    <th>Tên</th>
                    <th>Mã ĐVT</th>
                    <th>Giá</th>
                    <th>VAT</th>
                  </tr>
                  <tr v-for="(item, i) in listSuccess" :key="i">
                    <td>{{ item.sku }}</td>
                    <td>{{ item.item_name }}</td>
                    <td>{{ item.unit_id }}</td>
                    <td>{{ formatPrice(item.price) }}</td>
                    <td>{{ item.vat }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </form>
      <footer class="modal-footer px-0 pb-0">
        <button
          v-if="step === 1"
          type="button"
          class="btn btn-primary"
          @click="onCheckFile"
          :disabled="isLoadingCheck"
        >
          <template v-if="isLoadingCheck">
            <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
            Đang xử lý...
          </template>
          <template v-else>Tiếp tục</template>
        </button>
        <button
          v-if="step === 2 && listSuccess.length > 0"
          type="button"
          class="btn btn-primary ml-2"
          @click="onImport"
          :disabled="isLoadingCheck"
        >
          <template v-if="isLoadingCheck">
            <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
            Đang xử lý...
          </template>
          <template v-else>Import</template>
        </button>
      </footer>
    </b-modal>

    <replace-component ref="replaceComponent" @confirm="handleReplaceMultiple"/>
  </Layout>
</template>
